import {Component, Inject, OnInit, ViewChild} from "@angular/core";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CommonsService} from "../../../services/commons/commons.service";
import {DetailCompetenzaDialog} from "../detail-competenze/detail-competenza.component";
import {HttpService} from "../../../services/http/http.service";

@Component({
  selector: 'detail-profilo-component',
  templateUrl: './detail-profilo.component.html',
  styleUrls: ['./detail-profilo.component.scss']
})
export class DetailProfiloDialog implements OnInit {
  displayedColumns: string[] = ['competenza', 'eqf','digitale','green', 'azioni'];
  dataSource = new MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  title: string;
  datiProfilo: any;
  classificazioniAda: any;
  classificazioniIstat: any;
  classificazioniAteco: any;
  classificazioniIsco: any;
  competenze: any;
  paginatorSize: any;

  constructor(
    public dialogRef: MatDialogRef<DetailProfiloDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private commons: CommonsService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.title = this.data.title;

    this.commons.getProfiloDettaglio(this.data.id).subscribe({
      next: (response: any) => {
        this.datiProfilo = response.result;
      }
    })

    this.commons.getCodiciAdaByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAda = response.result;
      }
    })

    this.commons.getCodiciIstatByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIstat = response.result;
      }
    })

    this.commons.getCodiciAtecoByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAteco = response.result;
      }
    })

    this.commons.getCodiciIscoByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIsco = response.result;
      }
    })

    this.commons.getCompetenzeByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.competenze = response.result;
        this.paginatorSize = response.result.count;
        this.dataSource = this.competenze;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  openDettaglioCompetenza(el: any) {

    const {
      title,
      datiProfilo,
      classificazioniAda,
      classificazioniIstat,
      classificazioniAteco,
      classificazioniIsco,
      competenze,
      paginatorSize,
      paginator,
      displayedColumns,
      dataSource
    } = this;

    const dialogRef = this.dialog.open(DetailCompetenzaDialog, {

      data: {
        id: el.id, title,
        datiProfilo,
        classificazioniAda,
        classificazioniIstat,
        classificazioniAteco,
        classificazioniIsco,
        competenze,
        paginatorSize,
        paginator,
        displayedColumns,
        dataSource
      },
      height: '95%',
      width: '100%',
      panelClass: 'detail-competenza-dialog'
    });


    dialogRef.afterClosed().subscribe((result: any) => {

    })
  }

}
